import React, { useEffect } from "react";
import { Banner } from "../../components/Banner/Banner";
import Dash from "../../components/Dash/Dash";
import {
  thumbnail,
  blog2,
  blog3,
  blogsBanner,
  blog4Thumbnail,
  blog5Thumbnail,
  blog7,
  blog6,
  blog8,
  blog9,
  blog10,
  blog11,
  blog12,
  blog13,
  blog14,
  blog15,
  blog16,
  blog17,
  blog18,
  blog19,
  blog20,
  blog21,
  blog22,
  blog23,
  blog24,
  blog25,
  blog26,
} from "../../images";
import { Link, NavLink } from "react-router-dom";
//utils
import { reduceDescSize } from "../../helpers/utils";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";

import "./Blog.scss";
import {
  blog10innerURL,
  blog11innerURL,
  blog12innerURL,
  blog13innerURL,
  blog14innerURL,
  blog15innerURL,
  blog16innerURL,
  blog17innerURL,
  blog18innerURL,
  blog19innerURL,
  blog20innerURL,
  blog21innerURL,
  blog22innerURL,
  blog23innerURL,
  blog24innerURL,
  blog25innerURL,
  blog26innerURL,
  blog9innerURL,
} from "../../helpers/paths";

const Blogs = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id":
        "https://www.sanathan.com/blogs/driving-textile-innovation-how-sanathan-textiles-is-using-automation-to-build-a-smart-factory-in-punjab",
    },
    headline:
      "Driving Textile Innovation: How Sanathan Textiles is Using Automation to Build a Smart Factory in Punjab",
    description:
      "Discover how Sanathan Textiles is transforming the textile industry in Punjab through smart factory automation. Learn how advanced technology and innovation are driving efficiency, sustainability, and quality in yarn manufacturing.",
    image: "https://www.sanathan.com/static/media/blog_inner_18.b74d0189.jpg",
    author: {
      "@type": "Organization",
      name: "Sanathan Textiles",
      url: "https://www.sanathan.com/",
    },
    publisher: {
      "@type": "Organization",
      name: "Sanathan Textiles",
      logo: {
        "@type": "ImageObject",
        url: "https://www.sanathan.com/images/logo.png",
      },
    },
    datePublished: "2024-11-01",
    dateModified: "2024-11-01",
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const blogListArr = [
    {
      id: 1,
      url: "/blogs/recycled-pet-chip",
      img: thumbnail,
      date: "June 2, 2022",
      category: "Lorem Ipsum",
      title: "Recycled Pet Chips 101: Explained",
      description:
        "Polyester is one of the world’s most popular textiles and it is used in thousands of different consumer and industrial applications. Worldwide, more than 22.67 billion tonnes of polyester clothes are produced each year.",
    },
    {
      id: 2,
      img: blog2,
      url: "blogs/development-yarn-fibers",
      date: "August 12, 2022",
      category: "Lorem Ipsum",
      title: "What Are the Latest Yarn, And Fabric Developments?",
      description:
        "The fabrics and yarn industry is an essential component of the textile and apparel industries.",
    },
    {
      id: 3,
      img: blog3,
      url: "blogs/technical-textiles",
      date: "August 12, 2022",
      category: "Lorem Ipsum",
      title: "What Are Some Examples Of Technical Textiles?",
      description:
        "Technical textiles in India are a vital component of modern life. These materials are employed in a wide range of industries, from medical gadgets to athletic products. This article will provide an overview of technical textiles, their examples and how it is used nowadays.",
    },
    {
      id: 4,
      img: blog4Thumbnail,
      url: "blogs/re-weaving-indias-success-story",
      date: "September 22, 2022",
      category: "Lorem Ipsum",
      title: "Re-Weaving India’s Success Story",
      description:
        "India is globally known to set examples and break benchmarks as we proceed and lead from the front.",
    },
    {
      id: 5,
      img: blog5Thumbnail,
      url: "/blogs/polyester-yarn-market-in-india",
      date: "September 22, 2022",
      category: "Lorem Ipsum",
      title: "Polyester Yarn Market Report And The Price Trend In India 2022",
      description:
        "Polyester is the most cost-effective and versatile synthetic fibre available in the industry. Given that the global growth of natural fibres is constrained by available resources, only polyester would see further capacity expansion.",
    },
    {
      id: 6,
      url: "/blogs/technical-textile-innovations",
      img: blog7,
      date: "Sep 13, 2024",
      category: "Lorem Ipsum",
      title: "5 Breakthrough innovations in technical Textiles",
      description:
        "At Sanathan Textiles, our vision drives us to continually innovate in technical textiles, reflecting our dedication to advancing industry standards and meeting diverse application needs.",
    },
    {
      id: 7,
      url: "/blogs/types-of-yarn",
      img: blog6,
      date: "Sep 13, 2024",
      category: "Lorem Ipsum",
      title: "Types of Yarn at Sanathan Textiles: Everything you need to know",
      description:
        "Sanathan Textiles is a beacon in the textile business, where innovation meets tradition, providing a wide selection of yarns to meet customer specific demands. Sanathan Textiles has something for everyone, whether you work in fashion, technical textiles, or want to find sustainable solutions. Here's a closer look at the types of  yarns we offer refined to your unique requirements.",
    },
    {
      id: 8,
      url: "/blogs/craft-your-festive-wardrobe-with-sanathan-textile-yarns-for-blazers-suits-kurtas-and-sarees",
      img: blog8,
      date: "Sep 13, 2024",
      category: "Lorem Ipsum",
      title:
        "Craft Your Festive Wardrobe with Sanathan Textile Yarns for Blazers, Suits, Kurtas, and Sarees",
      description:
        "As the festive season approaches, the demand for ethnic/Indian outfits skyrockets, making it the perfect time to enhance your offerings with fancy textile yarns. At Sanathan Textiles, we specialize in providing fancy yarns that empower customers to create elegant blazers, suits, timeless kurtas, beautiful sarees & sherwani ensuring your collections are ready for the festive seasons.",
    },
    {
      id: 9,
      url: blog9innerURL,
      img: blog9,
      date: "Nov 11, 2024",
      category: "Lorem Ipsum",
      title:
        "The Future of Polyester Yarn in Textile and Clothing - Sanathan Textiles",
      description:
        "Explore groundbreaking advancements and evolving trends in polyester yarns. Learn how innovation and sustainability are shaping the future at Sanathan Textiles.",
    },
    {
      id: 10,
      url: blog10innerURL,
      img: blog10,
      date: "Nov 11, 2024",
      category: "Lorem Ipsum",
      title:
        "Cationic Dyeable Polyester Yarn:A Revolution in Fancy Innovative Fabrics | Sanathan Textiles",
      description:
        "Transform fabric innovation with cationic dyeable polyester yarn. Explore its role in creating vibrant, versatile, and sustainable fancy fabrics at Sanathan Textiles.",
    },
    {
      id: 11,
      url: blog11innerURL,
      img: blog11,
      date: "Nov 11, 2024",
      category: "Lorem Ipsum",
      title:
        "Leveraging Technology at Sanathan Textiles: Automation, Efficiency, and Data-Driven decision",
      description:
        "The global textile industry is evolving rapidly, and businesses need reliable partners who can deliver innovation, precision, and sustainability. Sanathan Textiles emerged as a frontrunner, leveraging cutting-edge technology to redefine manufacturing processes and meet the demands of modern enterprises.",
    },
    {
      id: 12,
      url: blog12innerURL,
      img: blog12,
      date: "Nov 11, 2024",
      category: "Lorem Ipsum",
      title: "S-flex Yarn - A Sanathan Textile Stretch Yarn Product.",
      description:
        "The textile industry is no stranger to innovation, but every once in a while, a product emerges that redefines the landscape. Enter S-Flex, a self-stretch polyester filament yarn that is setting a new standard for stretch yarns. What makes Spandex-free S-Flex stretch truly groundbreaking is its ability to deliver four-way stretch capabilities without relying on spandex. This innovation promises to revolutionize how we think about comfort, durability, and sustainability in fabrics.",
    },
    {
      id: 13,
      url: blog13innerURL,
      img: blog13,
      date: "Nov 11, 2024",
      category: "Lorem Ipsum",
      title:
        "Sanathan Textiles Integrated Manufacturing facility with 220,000+ MTPA Capacity Offers Diverse Yarn Products and High-Value Innovation.",
      description:
        "At Sanathan Textiles' Silvassa facility, we are committed to delivering high-quality yarn products through a meticulous and transparent production process. To uphold this vision, we are committed to maintaining a meticulous and transparent production process. Our integrated manufacturing setup in Silvassa boasts a capacity exceeding 220,000 MTPA, while our facility in Punjab is designed with a capacity of 3.50,000 MTPA at peak capacity, enabling the production of cotton yarn, polyester yarn, and yarns for technical textile.",
    },
    {
      id: 14,
      url: blog14innerURL,
      img: blog14,
      date: "Nov 11, 2024",
      category: "Lorem Ipsum",
      title:
        "Bharat Tex 2025: Celebrating innovation and transforming India’s textile industry.",
      description:
        "Bharat Tex 2025 was a platform for prominent leaders of the textile industry to showcase their innovation and efficiency.",
    },
    {
      id: 15,
      url: blog15innerURL,
      img: blog15,
      date: "Nov 11, 2024",
      category: "Lorem Ipsum",
      title:
        "How Mr. Khurshed Thanawalla's Board Appointment Will Propel Sanathan Polycot’s Greenfield Project in Punjab",
      description:
        "Sanathan Textiles believes that expansion is not just about increasing capacity; it's about embracing innovation, optimizing efficiency, and strengthening our foundation for sustainable growth. In manufacturing, true expansion is measured not just in scale, but in impact, adaptability, and the ability to shape the future of the industry. Further, to shape the future, its right to say that we need seasoned professionals to guide the growth with their experience.",
    },
    {
      id: 16,
      url: blog16innerURL,
      img: blog16,
      date: "Nov 11, 2024",
      category: "Lorem Ipsum",
      title:
        "Sanathan Textiles: Strategically expanding by doubling our Polyester Filament Yarn capacity in Punjab",
      description:
        "The land of five rivers - Punjab today has become an important textile hub for the nation. Being the jewel of the farming industry, Punjab has transformed itself into one of the most important states in India. The skilled workforce and infrastructure creativity are among the few reasons why industrialists are adding a new setup to the region.",
    },
    {
      id: 17,
      url: blog17innerURL,
      img: blog17,
      date: "Nov 11, 2024",
      category: "Lorem Ipsum",
      title:
        "How Sanathan Textiles is Shaping the Future of Yarn Manufacturing in Punjab's Thriving Textile Ecosystem",
      description:
        "Punjab is the leading producer of blended yarns and upholds its position as the largest hosiery production. Around 97 Million Kg of Yarns is produced annually in Punjab. Punjab being the epicentre for agriculture and its location has not only attracted giant yarn-producing companies for strategic expansion but its skilled artisans have propelled entrepreneurial spirit too. ",
    },
    {
      id: 18,
      url: blog18innerURL,
      img: blog18,
      date: "Nov 11, 2024",
      category: "Lorem Ipsum",
      title:
        "Driving Textile Innovation: How Sanathan Textiles is Using Automation to Build a Smart Factory in Punjab",
      description:
        "Punjab has been playing a vital role in revolutionising the country and contributing to the overall growth of India. It is not only the beating heart of India’s textile sector but also its legacy built by skilled artisans for fabric weaving and garment manufacturing. The sector is a major economic driver for the state, accounting for about 31% of Punjab’s manufacturing Gross Value Added (GVA).",
    },
    {
      id: 19,
      url: blog19innerURL,
      img: blog19,
      date: "Nov 11, 2024",
      category: "Lorem Ipsum",
      title:
        "Sanathan Textiles is building a stronger foundation and expanding responsibly",
      description:
        "The narrative of India’s textile industry is being rewritten. With the focus shifting on efficiency and expansion, the new phase of growth integrates state-of-the-art technology and innovative methods to expand responsibly. Rooted in expansion, Sanathan Textiles begins a new phase of yarn production for local and global supply with its Silvassa and Wazirabad production plants.",
    },
    {
      id: 20,
      url: blog20innerURL,
      img: blog20,
      date: "Nov 11, 2024",
      category: "Lorem Ipsum",
      title:
        "Powering North India’s Textile Market to New Heights with Technology and Sustainable Solutions",
      description:
        "Sanathan Textiles turns its page of success and weaves its legacy of being a titan in India’s textile industry with the commissioning of its new plant. Inaugurated in the heart of Punjab city, our Wazidarabad plant has a capacity to produce 950 MTPD of polyester yarn. Armed with innovation and resilience on the path to success, we commit to sustainability and meet the growing demand for yarns in the North India Textile Market. By assessing the logistical barriers of the northern markets, we culminate to progress one yarn at a time.",
    },
    {
      id: 21,
      url: blog21innerURL,
      img: blog21,
      date: "Nov 11, 2024",
      category: "Lorem Ipsum",
      title:
        "The Textile Industry Gains Leverage With The Value-Led Economic Partnership from the India–EU FTA",
      description:
        "The textile industry has been the backbone of India’s export economy for decades and has seen accelerated growth. While it is buoyed by competitive labour costs and an expansive range of product offering, the textile industry also heavily relies on key markets, especially international markets. American and European markets have resulted in a massive shift in tariff regimes and global trade policies.",
    },
    {
      id: 22,
      url: blog22innerURL,
      img: blog22,
      date: "Nov 11, 2024",
      category: "Lorem Ipsum",
      title: "Sanathan Textiles Empowers Women With A Thoughtful Initiative",
      description:
        "Women embody strength and courage, and true empowerment blooms with recognising and appreciating their efforts across communities and industries. They bring a gentle rhythm to our everyday lives, and every year, Sanathan Textiles pauses and reflects on the journey of women and how far they have come.",
    },
    {
      id: 23,
      url: blog23innerURL,
      img: blog23,
      date: "Nov 11, 2024",
      category: "Lorem Ipsum",
      title: "Sanathan Textiles Kept Its Promise & Made It Happen With Precision, Consistency And Determination",
      description:
        "Sanathan Textiles firmly believes in delivering its promise, and there is a particular pride in not announcing ambitions but making them happen. Our Phase 1 has reached its operational excellence and is producing 700 tonnes per day, a milestone in itself. Sanathan Textiles unveiled its Wazirabad, Punjab plant on August 27th, 2025, and in the span of 6 months, we have underscored the commitment to scaling with purpose and delivering on time as a leading yarn supplier for the North India Textile Market.",
    },
    {
      id: 24,
      url: blog24innerURL,
      img: blog24,
      date: "may, 2026",
      category: "Lorem Ipsum",
      title: "Sanathan Textiles: A Year Of Meaningful Progress & Purpose",
      description:
        "At Sanathan Textiles, FY26 wasn't just a strong year. It was a year that proved our foundation. We grew, we scaled, and we stayed true to every commitment that matters. ",
    },
    {
      id: 25,
      url: blog25innerURL,
      img: blog25,
      date: "June, 2026",
      category: "Lorem Ipsum",
      title:
        "Cotton Import Duty Exempted - A Relief & What It Actually Means For The Indian Textile Sector",
      description:
        "The decision of the Union Government to exempt raw cotton imports from customs duty and the Agriculture Infrastructure and Development Cess comes at a crucial time for India's textile sector.",
    },
    {
      id: 26,
      url: blog26innerURL,
      img: blog26,
      date: "June, 2026",
      category: "Lorem Ipsum",
      title:
        "Beyond Clothing: How Sanathan's Technical Textile Expansion Strengthens Everyday Industries",
      description:
        "Most people associate yarn with clothing. Few realise that the same foundation also powers automotive, agriculture, defence, infrastructure, roads and railways, sportswear, healthcare and industrial safety applications, as well as protective and strategic end-uses such as fire-retardant wear.  Technical textile yarns are built not for appearance, but for performance, safety and reliability, making them one of the fastest-growing segments in modern manufacturing.",
    },
  ];

  const blogList = blogListArr.length ? (
    blogListArr.reverse().map((blog, i) => (
      <div className="col-md-6 col-lg-4 blog_details_container" key={i}>
        <div className="blog_detail_wrapper">
          <Link to={blog.url} className="blog_card">
            <div className="imageanimate zoom-out">
              <img
                src={blog.img}
                alt="caterina our blog img"
                loading="lazy"
                className="blog_img"
              />
              {/* <div className="content-overlay"></div> */}
            </div>
            <div className="text_container">
              {/* <h1 className="blog_date">{blog.date} </h1>
              <div className="verticle_line"> | </div>
              <h1 className="blog_category">{blog.category}</h1> */}
              <h2 className="blog_name"> {blog.title}</h2>
              <p className="blog_synopsis">
                {reduceDescSize(blog.description, 100)}
              </p>
              <div className="blog_cta_wrapper">
                <button className="readmore_button">Read More</button>
              </div>
            </div>
          </Link>
        </div>
      </div>
    ))
  ) : (
    <h1>No Blogs Found</h1>
  );
  return (
    <>
      <MetaDecorator
        canonicalLink={window.location.href}
        metaTitle="Blogs | Sanathan Textiles"
        metaDesc="Explore the world of textiles with Sanathan Textile's Insights on quality fabrics, Yarns & Customised Yarns. Visit Us and Read More Now!"
        schema={schema}
      />
      <section className="newsroom">
        <div className="wrapper">
          <div className="breadcrumb_styles">
            <Link to="/" className="breadcrumb_link">
              Home
            </Link>{" "}
            {">"} Blogs
          </div>
          <div className="left_section">
            <h1 className="hollow_title">Blogs</h1>
            <div className="dash_wrapper">
              <Dash />
            </div>
            <p>
              Textile blogs have now become a trending and binge-worthy blog
              category. At Sanathan Textiles, we strive to provide you with
              relevant blogs from the industry along with hot fabric/textile
              news that you can feed on!
            </p>
          </div>
          <figure className="bg_img bg_img_desktop">
            <img src={blogsBanner} alt="sanathan img" />
          </figure>
        </div>
      </section>
      <figure className="bg_img bg_img_mobile wrapper">
        <img src={blogsBanner} alt="sanathan img" />
      </figure>
      <section className="blog_sec2">
        <div className="wrapper">
          {/* <div className="breadcrumb_styles">Home {">"} Blogs</div> */}
          <div className="row m-0">{blogList}</div>
          {/* <div className="horizontal_line"></div> */}
          <div className="loadmore_cta_wrapper center"></div>
        </div>
      </section>
    </>
  );
};

export default Blogs;
